import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "searchFormIsOpen", true);
        Vue.set(state, "gridIsOpen", false);
    },
    setSearchFormOpen(state) {
        state.searchFormIsOpen = true;
        state.gridIsOpen = false;
    },
    setSearchFormClose(state) {
        state.searchFormIsOpen = false;
        state.gridIsOpen = true;
    }
}
